import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g>
        <g id="B" transform="translate(28.000000, 28.000000)">
          <path
            d="
          M 40.95 32.551 L 40.95 0.001 L 45.36 0.001 L 45.36 43.541 L 40.11 43.541 L 31.08 9.801 L 31.08 43.541 L 26.67 43.541 L 26.67 0.001 L 32.27 0.001 L 40.95 32.551 Z M 0 43.541 L 0 0.001 L 13.79 0.001 Q 19.32 0.001 19.32 5.531 L 19.32 38.011 Q 19.32 43.541 13.79 43.541 L 0 43.541 Z M 14.49 37.241 L 14.49 6.301 Q 14.49 4.901 14.07 4.516 Q 13.652 4.132 12.33 4.131 A 9.203 9.203 0 0 0 12.32 4.131 L 4.83 4.131 L 4.83 39.411 L 12.32 39.411 A 7.28 7.28 0 0 0 12.858 39.392 Q 13.742 39.327 14.07 39.026 A 0.894 0.894 0 0 0 14.273 38.729 Q 14.48 38.268 14.49 37.329 A 9.014 9.014 0 0 0 14.49 37.241 Z
          "
            fill="currentColor"
          />
        </g>
        <path
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
                  
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
